export default __webpack_public_path__ + "static/media/watermark.947a6181.png";